import { camelizeKeys } from 'humps';

const parsePassenger = (user, previousParams = {}) => {
  if (!user) return null;
  const camelizedUser = camelizeKeys(user);
  const firstName = camelizedUser.firstName || camelizedUser.name;
  let name = `${firstName} ${camelizedUser.lastName}`;
  if (camelizedUser.secondLastName) name = `${name} ${camelizedUser.secondLastName}`;

  return {
    ...previousParams,
    firstName,
    lastName: camelizedUser.lastName,
    secondLastName: camelizedUser.secondLastName,
    name,
    email: camelizedUser.email,
    // Deliberately unconditional, unlike documentType below. The only caller that passes
    // previousParams is changeFirstPassenger (actions/loyalty.js), which re-stamps `category:
    // 'adult'` and `busCategory: 'general'` on the result anyway: it replaces passenger 0 with the
    // loyalty account holder, who is the buyer. Deferring to previousParams here would change
    // nothing there and would let an unrelated caller hydrate an account into a minor's slot.
    category: 'adult',
    busCategory: 'general',
    // Only stamped when the hydrated user has none of its own. It used to overwrite whatever the
    // account carried, which put a Cédula on passengers who may not hold one.
    documentType: camelizedUser.documentType || previousParams?.documentType || 'CC',
  };
};

export const formatName = (passenger) => {
  const name = `${passenger.firstName} ${passenger.lastName || ''} ${
    passenger.secondLastName || ''
  }`.trim();
  return {
    ...passenger,
    name,
  };
};

export default parsePassenger;
